import { useState, useEffect } from "react";
import "./PermissionsGrid.css";
import ApiManager from "../../ApiManager/ApiManager";

const PermissionsGrid = ({setSelectedPermissionGroups}) => {
  // const [permissions, setPermissions] = useState({ read: [], create: [], update: [] });
  const [permissions, setPermissions] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  useEffect(() => {
    fetchPermissionGroups();
  }, []);


  useEffect(() => {
    console.log("Updated selectedPermissions", selectedPermissions);
    setSelectedPermissionGroups(selectedPermissions);
  }, [selectedPermissions]);

  const fetchPermissionGroups = async () => {
    try {
      const response = await ApiManager.getAllPermissionGroups();
      if (!response.ok) throw new Error('Network response was not ok');
      const json = await response.json();
      setPermissions(json);
      console.log("permission groups ", json);
    } catch (error) {
      console.log('Error fetching data:', error);
    }
  };

  const handleCheckboxChange = (permId) => {
    setSelectedPermissions((prev) =>
      prev.includes(permId) ? prev.filter((p) => p !== permId) : [...prev, permId]
    );
  };

  const renderColumns = (type) => (
    <div className="column">
      <h2 className="column-title">{type} Permissions</h2>
      <div className="permissions-set">
        {permissions.map((perm, index) => (
          <div key={index} className="permission-item">
            <div className="permission-checkbox">
              <input
                type="checkbox"
                onChange={() => handleCheckboxChange(perm.id)}
                checked={selectedPermissions.includes(perm.id)}
              />
            </div>
            <div className="permission-details">
              <p className="permission-name"><strong>{perm.name}</strong> ({perm.description})</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="permissions-container">
      {renderColumns("read")}
      {renderColumns("create")}
      {renderColumns("update")}
      {/* <button className="submit-button" onClick={sendSelectedPermissions}>Submit</button> */}
    </div>
  );
};

export default PermissionsGrid;
